import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Customer } from './types';

export const useCustomerEmailVerifyRequest = createMutation<{}, {}, AxiosError>(
  {
    mutationFn: async () =>
      client({
        url: 'v2/customers/me/email/verify-request',
        method: 'POST',
      })
        .then((response) => response.data)
        .catch((err: any) => {
          throw new Error(err.response.data.errors.join(', '));
        }),
  }
);

type EmailVerifyCustomerResponse = { data: Customer };
type Variables = { token: string };

export const useCustomerEmailVerify = createMutation<
  EmailVerifyCustomerResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ token }) =>
    client({
      url: 'v2/customers/me/email/verify',
      method: 'POST',
      data: {
        token,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
